// @ts-nocheck


import React, { useCallback, useMemo, useState } from 'react';
import Select from 'antd/lib/select';

import { convertVehicleToString } from '../../../../../lib/helpers';


const { Option } = Select;






export const VehiclesSelect = ({ vehicles, onChange }) => {
  const [value, setValue] = useState(0);

  const handleChange = useCallback(
    (value) => {
      const newValue = vehicles.find((vehicle) => vehicle.id === value);
      onChange(newValue);
      setValue(value);
    },
    [onChange, vehicles]
  );

  const renderedOptions = useMemo(() => {
    return vehicles.map((vehicle) => {
      return (
        <Option key={vehicle.id} value={vehicle.id}>
          {convertVehicleToString(vehicle.vehicle)}
        </Option>);

    });
  }, [vehicles]);

  return (
    <Select
      optionFilterProp="children"
      showSearch
      filterOption={(input, option) => {
        return (
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0);

      }}
      placeholder="Гос. номер"
      value={value}
      onChange={handleChange}>

      {renderedOptions}
    </Select>);

};
